<template>
    <div>
        <v-container fluid class="pt-0 pb-0">
            <v-form ref="queryForm"
                    class="mb-6">
                <v-row align="center"
                       no-gutters
                       justify="start"
                       class="pl-1">
                    <v-col md="auto" class="font-weight-bold">设备归属方</v-col>
                    <v-col cols="2"
                           class="pl-6">
                        <z-source-selector :search="true" label="请选择部门"
                                           :hide-details="'auto'"
                                           :isDisabled="batchModifyFlag"
                                           v-model="queryRequest.propertyOwnerDeptId"
                                           :source="'DeptSelector'"/>
                    </v-col>
                    <v-col cols="2"
                           class="pl-6">
                        <v-text-field label="联系人" v-model="queryRequest.propertyOwnerPerson"
                                      :disabled="batchModifyFlag"
                                      :hide-details="'auto'"
                                      prepend-inner-icon="search" clearable></v-text-field>
                    </v-col>
                    <v-col offset="2" cols="5" class="d-flex align-center justify-center">
                        <v-switch v-model="batchModifyFlag" label=""></v-switch>
                        <v-btn color="primary" :disabled="!batchModifyFlag||selected.length<1"
                               @click='showDialog=true'>
                            批量修改({{selected.length}})
                        </v-btn>
                        <v-btn class="ml-4"
                               :disabled="!batchModifyFlag||selected.length<1"
                               color="primary"
                               @click='productOff'>
                            批量下架({{selected.length}})
                        </v-btn>
                        <v-btn class="ml-4" :disabled="!batchModifyFlag||selected.length<1"
                               color="primary"
                               @click='productOn'>
                            批量上架({{selected.length}})
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row align="center"
                       no-gutters
                       justify="start"
                       class="pl-1">
                    <v-col md="auto" class="font-weight-bold">设备管理方</v-col>
                    <v-col cols="2" class="pl-6">
                        <z-source-selector :search="true" label="请选择部门"
                                           :isDisabled="batchModifyFlag"
                                           :hide-details="'auto'"
                                           v-model="queryRequest.assetsManageDeptId"
                                           :source="'DeptSelector'"/>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field label="负责人" prepend-inner-icon="search"
                                      :disabled="batchModifyFlag"
                                      :hide-details="'auto'"
                                      v-model="queryRequest.assetsManager" clearable></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field label="检索标签" prepend-inner-icon="search"
                                      :disabled="batchModifyFlag"
                                      :hide-details="'auto'"
                                      v-model="queryRequest.searchTag"
                                      clearable></v-text-field>
                    </v-col>
                    <v-col cols="3" class="pl-6" align="left">
                        <v-btn color="primary"
                               :disabled="batchModifyFlag"
                               @click="query">搜索
                        </v-btn>
                        <v-btn
                                :disabled="batchModifyFlag"
                                color="primary"
                                class="ma-2"
                                @click="resetQuery"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                       no-gutters
                       justify="start"
                       align="center">
                    <v-col cols="2">
                        <z-source-selector :search="false"
                                           label="设备类型"
                                           :hide-details="'auto'"
                                           param="ASSETS_TYPE"
                                           :isDisabled="batchModifyFlag"
                                           v-model="queryRequest.assetsType"
                        ></z-source-selector>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field label="设备名称"
                                      :hide-details="'auto'"
                                      :disabled="batchModifyFlag"
                                      v-model="queryRequest.assetsName"
                                      prepend-inner-icon="search"
                                      clearable></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field label="品牌"
                                      :hide-details="'auto'"
                                      :disabled="batchModifyFlag"
                                      v-model="queryRequest.assetsBrand"
                                      prepend-inner-icon="search"
                                      clearable></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field label="型号"
                                      :hide-details="'auto'"
                                      :disabled="batchModifyFlag"
                                      v-model="queryRequest.assetsModel"
                                      prepend-inner-icon="search"
                                      clearable></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <z-source-selector :search="false"
                                           :isDisabled="batchModifyFlag"
                                           label="状态"
                                           :hide-details="'auto'"
                                           v-model="queryRequest.assetsState"
                                           param="ASSETS_STATE"></z-source-selector>
                    </v-col>
                </v-row>
                <v-row justify="start"
                       no-gutters>
                    <v-col cols="2">
                        <v-text-field label="设备编号"
                                      :hide-details="'auto'"
                                      :disabled="batchModifyFlag"
                                      v-model="queryRequest.assetsCode"
                                      prepend-inner-icon="search"
                                      clearable></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                        <v-text-field
                                label="出厂序列号"
                                :hide-details="'auto'"
                                :disabled="batchModifyFlag"
                                prepend-inner-icon="search"
                                clearable
                                v-model="queryRequest.factSerialNo"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pl-6">
                      <z-source-selector :search="true" label="当前所在科室"
                                         :isDisabled="batchModifyFlag"
                                         :hide-details="'auto'"
                                         v-model="queryRequest.currentLocationDeptId"
                                         :source="'DeptSelector'"/>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <v-row justify="center">
            <v-col cols="11">
                <v-card>
                    <v-data-table
                            :single-select="false"
                            :show-select="batchModifyFlag"
                            v-model="selected"
                            :headers="headers"
                            disable-sort
                            single-expand
                            show-expand
                            :server-items-length="total"
                            :items="list"
                            :page.sync="queryRequest.pagedQueryInfo.index"
                            :options.sync="options"
                            :footer-props="footerOptions"
                    >
                      <template v-slot:item.borrow—record="{ item }">
                        <v-btn small color="primary lighten-1" class="mr-1" width="83px" dark
                               @click="toBorrowRecordPage(item.assetsCode)">
                          借用记录
                        </v-btn>
                      </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length/3">
                                <div style="padding:10px 0;">
                                  <span>产权归属部门</span>：
                                  <span>{{item.propertyOwnerDept}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>产权归属联系人</span>：
                                    <span>{{item.propertyOwnerPerson}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>产权归属联系电话</span>：
                                    <span>{{item.propertyOwnerPhone}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>共享设备管理部门</span>：
                                    <span>{{item.assetsManageDept}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>管理方负责人</span>：
                                    <span>{{item.assetsManager}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>管理方负责人电话</span>：
                                    <span>{{item.assetsManagerPhone}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>设备图片</span>：
                                    <v-row>
                                        <v-col cols="4"
                                               v-for="(itemImg,index) in item.assetsImgList"
                                               :key="index">
                                            <v-img :src="itemImg"
                                                   aspect-ratio="1.7"
                                                   contain></v-img>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>借用审批开关</span>：
                                    <span>{{item.borrowApproveSwitch?'开':'关'}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>归还验收开关</span>：
                                    <span>{{item.returnApproveSwitch?'开':'关'}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>借用人角色验收权限</span>：
                                    <span>{{item.borrowerReturnApproveSwitch?'开':'关'}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>累计借用次数</span>：
                                    <span>{{item.borrowCount}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>累计借用时间</span>：
                                    <span>{{item.borrowTime}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>上次归还时间</span>：
                                    <span>{{item.lastReturnTime}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>预计可借用时间</span>：
                                    <span>{{item.expectBorrowTime}}</span>
                                </div>
                                <div style="padding:10px 0;">
                                    <span>当前位置</span>：
                                    <span>{{item.currentLocation}}</span>
                                </div>
                            </td>
                            <td valign="top" :colspan="headers.length - headers.length/3">
                                <div style="padding:10px ;" >
                                    <span>最新下架时间</span>：
                                    <span>{{item.offShelfLstTime}}</span>
                                </div>
                                <div style="padding:10px;">
                                    <span>下架备注</span>：
                                    <span>{{item.offShelfRemark}}</span>
                                </div>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>


        <batch-update width="500px"
                      :idList="selected"
                      @submit="handleQuery"
                      title="设备批量更新"
                      :show.sync="showDialog">
        </batch-update>

        <v-dialog v-model="isShowConfirm" persistent max-width="500">
            <v-card>
                <v-card-title v-if="isOffAssets == '00'">提示</v-card-title>
                <v-card-title v-else>下架备注</v-card-title>
                <v-card-text v-if="isOffAssets == '00'">{{confirmMsg}}</v-card-text>
                <v-card-text v-else>
                    <v-textarea outlined  placeholder="请输入备注"
                                v-model="offShelfRemark"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="isShowConfirm = false">取消</v-btn>
                    <v-btn color="primary" @click="confirmBtn">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <z-notify ref="notify"></z-notify>

    </div>

</template>

<script>
  import {
    pagedQuery,
    batchChangeState,
  } from "@/api/assetsManagement";
  import ZSourceSelector from "@/components/ZSourceSelector";
  import ZSelectDate from "@/components/ZSelectDate";
  import ZConfirm from "@/components/ZConfirm";
  import BatchUpdate from "./components/BatchUpdate";

  export default {
    name: "AssetsManagement",
    components: {
      ZSourceSelector,
      ZSelectDate,
      ZConfirm,
      BatchUpdate
    },
    data() {
      return {
        offShelfRemark: '',
        batchModifyFlag: false,
        isShowConfirm: false,
        confirmMsg: '',
        isOffAssets: false,
        search: '',
        showDialog: false,
        fieldList: [],
        updateRequest: {
          eqpName: "",
          eee: ""
        },
        selectFields: [],
        options: {},
        color: false,
        el: 1,
        active: 1,
        dialog: false,
        singleSelect: true,
        selected: [],
        queryRequest: {
          assetsBrand: "",
          assetsModel: "",
          factSerialNo: "",
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          },
          state: "",
          assetsCode: "",
          assetsName: "",
          assetsType: "",
          searchTag: "",
          propertyOwner: "",
          propertyOwnerId: "",
          propertyOwnerDept: "",
          propertyOwnerDeptId: "",
          propertyOwnerPerson: "",
          propertyOwnerPersonId: "",
          assetsManage: "",
          assetsManageId: "",
          assetsManageDept: "",
          assetsManageDeptId: "",
          currentLocationDeptId: "",
          assetsState: "",
          assetsManager: ""
        },
        total: 9,
        list: [],
        loading: false,
        headers: [
          {
            text: "设备编号",
            value: "assetsCode",
            align: 'center'
          },
          {
            text: "设备名称",
            value: "assetsName",
            align: 'center'
          },
          {
            text: "出厂序列号",
            align: 'center',
            value: "factSerialNo"
          },
          {
            text: "品牌",
            value: "assetsBrand",
            align: 'center'
          },
          {
            text: "型号",
            align: 'center',
            value: "assetsModel"
          },
          {
            text: "当前位置",
            align: 'center',
            value: "currentLocation"
          },
          // {
          //   text: "产权归属部门",
          //   align: 'center',
          //   value: "propertyOwnerDept"
          // },
          {
            text: "管理方",
            align: 'center',
            value: "assetsManageDept"
          },
          {
            text: "状态",
            align: 'center',
            value: "assetsStateDesc"
          },
          {
            text: "健康状态",
            align: 'center',
            value: "healthStateDesc"
          },
          {
            text: "收费标准",
            align: 'center',
            value: "feeScale"
          },
          {
            text: "成本",
            align: 'center',
            value: "price"
          },
          {
            text: "总营收",
            align: 'center',
            value: "revenue"
          },
          {
            text: "借用记录",
            align: 'center',
            value: "borrow—record"
          },
          {
            text: "详情",
            align: 'center',
            value: "data-table-expand"
          }
        ],
        footerOptions:{
          itemsPerPageOptions:[10,30,100,500]
        }
      };
    },
    watch: {
      batchModifyFlag(newValue, oldValue) {
        if (!newValue) {
          this.selected = [];
        }
      },
      options: {
        handler(val) {
          // 点击分页的全部是-1
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1;
            this.queryRequest.pagedQueryInfo.pageSize = 999999;
          } else if (!!val.page && !!val.itemsPerPage) {
            this.queryRequest.pagedQueryInfo.index = val.page;
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage;
          }
          // this.queryRequest.sortInfo.sortBy = val.sortBy
          // this.queryRequest.sortInfo.sortDesc = val.sortDesc
          this.handleQuery();
        }
      }
    },
    methods: {
      confirmBtn() {
        var req = {
          idList: [],
          state: this.isOffAssets ? '01' : '00',
          offShelfRemark: this.offShelfRemark
        };
        for (var i = 0; i < this.selected.length; i++) {
          req.idList.push(this.selected[i].id);
        }
        batchChangeState(req).then(res => {
          this.isShowConfirm = false;
          this.$refs.notify.show((this.isOffAssets ? '下架' : '上架') + "操作成功", {timeout: 1000, color: 'success'});
          // alert(this.queryRequest.pagedQueryInfo.index);
          this.handleQuery();
          this.offShelfRemark = '';
        }).catch(err => {

        });
      },
      // 下架
      productOff() {
        this.isShowConfirm = true;
        this.isOffAssets = true;
        this.confirmMsg = '确认下架吗？'
      },
      // 上架
      productOn() {
        this.isShowConfirm = true;
        this.isOffAssets = false;
        this.confirmMsg = '确认上架吗？'
      },
      query() {
        this.queryRequest.pagedQueryInfo.index = 1;
        this.handleQuery();
      },
      handleQuery() {
        this.loading = true;
        pagedQuery(this.queryRequest).then(res => {
          this.list = res.list;
          this.total = res.total;
          this.loading = false;
        }).catch(err => {
          this.loading = false;
        });
      },
      resetQuery() {
        Object.assign(this.$data, this.$options.data());
      },
      //跳转页面
      toBorrowRecordPage(assetsCode) {
        this.$router.push({
          path: '/record-query?assetsCode=' + assetsCode
        });
        this.$store.dispatch('setCurretTitle', '共享记录查询');
      },
    },
    created() {
      if (this.$route.query.assetsName) {
        this.queryRequest.assetsName = this.$route.query.assetsName;
      }
      if (this.$route.query.currentLocationDeptId) {
        this.queryRequest.currentLocationDeptId = this.$route.query.currentLocationDeptId;
      }
    }
  };
</script>

<style scoped>

</style>